import { render, staticRenderFns } from "./PolicyAxesa.vue?vue&type=template&id=4f761eee&scoped=true&"
import script from "./PolicyAxesa.vue?vue&type=script&lang=js&"
export * from "./PolicyAxesa.vue?vue&type=script&lang=js&"
import style0 from "./PolicyAxesa.vue?vue&type=style&index=0&id=4f761eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f761eee",
  null
  
)

export default component.exports